<template>
  <v-flex shrink>
    <v-layout class="my-2" row shrink align-center>
      <v-icon class="mr-2" :color="iconColor">
        {{ icon }}
      </v-icon>
      <v-flex shrink>
        <v-flex class="font-weight-black">
          {{ title }}
        </v-flex>

        <v-flex shrink>
          {{ subtitle }}
        </v-flex>
      </v-flex>
    </v-layout>
  </v-flex>
</template>
<script>
export default {
  props: ["icon", "iconColor", "title", "subtitle"]
};
</script>
